import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { KeyPortMessage } from '../../types/KeyPortMessage';
import type { ValidationResponse } from '../../types/ValidationResponse';
import { updateKeyPort } from '../common/api/clients/keyPorts.api';
import type { UpdateKeyPortParams } from '../common/api/clients/keyPorts.api';
import { queries } from '../common/api/queryKeys/queries';

export const useKeyPortEdit = () => {
    const queryClient = useQueryClient();

    return useMutation<KeyPortMessage, AxiosError<ValidationResponse>, UpdateKeyPortParams>({
        mutationFn: updateKeyPort,
        onSuccess: (keyPort) => {
            queryClient.removeQueries({ queryKey: queries.keyPorts.detail(keyPort.id).queryKey });
            queryClient.invalidateQueries({ queryKey: queries.keyPorts._def });
        },
    });
};
